module.exports = {
	"Play": "Reproducción",
	"Pause": "Pausa",
	"Current Time": "Tiempo reproducido",
	"Duration Time": "Duración total",
	"Remaining Time": "Tiempo restante",
	"Stream Type": "Tipo de secuencia",
	"LIVE": "DIRECTO",
	"Loaded": "Cargado",
	"Progress": "Progreso",
	"Fullscreen": "Pantalla completa",
	"Non-Fullscreen": "Pantalla no completa",
	"Mute": "Silenciar",
	"Unmute": "No silenciado",
	"Playback Rate": "Velocidad de reproducción",
	"Subtitles": "Subtítulos",
	"subtitles off": "Subtítulos desactivados",
	"Captions": "Subtítulos especiales",
	"captions off": "Subtítulos especiales desactivados",
	"Chapters": "Capítulos",
	"You aborted the media playback": "Ha interrumpido la reproducción del vídeo.",
	"A network error caused the media download to fail part-way.": "Un error de red ha interrumpido la descarga del vídeo.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "No se ha podido cargar el vídeo debido a un fallo de red o del servidor o porque el formato es incompatible.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "La reproducción de vídeo se ha interrumpido por un problema de corrupción de datos o porque el vídeo precisa funciones que su navegador no ofrece.",
	"No compatible source was found for this media.": "No se ha encontrado ninguna fuente compatible con este vídeo."
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/es.json
// module id = 248
// module chunks = 86